import React from "react";
import { bool, node, string } from "prop-types";

import * as S from "./styled";

const Label = ({ children, hint, ...props }) => (
  <S.Label {...props}>
    {children}
    {hint && <S.Hint> ({hint})</S.Hint>}
  </S.Label>
);

Label.propTypes = {
  isFocused: bool,
  hint: string,
  children: node.isRequired
};

Label.defaultProps = {
  isFocused: false,
  hint: ""
};

export default Label;
